<template>
  <v-layout>
    <v-flex>
      <v-layout wrap align-center>
        <h1 class="headline">Transport</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              fab
              dark
              color="primary"
              @click="onCreateItem"
              class="ma-2"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Transport</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="id"
          fixed-header
          hide-default-footer
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="onDeleteItem"
              @editItem="onEditItem"
            ></default-list-actions>
          </template>
          <template v-slot:item.notInUse="{ item }">
            <v-simple-checkbox
              v-model="item.notInUse"
              disabled
            ></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-card>
      <transport-type-edit-dialog
        :show="showEditDialog"
        @close="showEditDialog = false"
        v-model="editedItem"
        @input="onSave"
      ></transport-type-edit-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_TRANSPORT_SERVICE_TYPES_SEARCH_QUERY,
  TRANSPORT_SERVICE_TYPE_CREATE_MUTATION,
  TRANSPORT_SERVICE_TYPE_DELETE_MUTATION,
  TRANSPORT_SERVICE_TYPE_UPDATE_MUTATION,
} from "../../../../constants/graphql";

import TransportTypeEditDialog from "./TransportTypeEditDialog";
import DefaultListActions from "../../shared/DefaultListActions";
import { pagingOptions } from "../../../../helpers/index";
import SimpleListMixin from "../../../../mixins/SimpleListMixin";
import BasicCrudMixin from "../../../../mixins/BasicCRUD";
export default {
  name: "TransportTypesList",

  mixins: [SimpleListMixin, BasicCrudMixin],

  components: {
    DefaultListActions,
    TransportTypeEditDialog,
  },

  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Sales Nominal Code",
          value: "salesNominalCode",
          name: "salesNominalCode",
        },
        {
          text: "Purchase Nominal Code",
          value: "purchaseNominalCode",
          name: "purchaseNominalCode",
        },
        {
          text: "Tax Code",
          value: "taxCode",
          name: "taxCode",
        },
        {
          text: "Std Occupancy",
          align: "left",
          value: "stdOccupancy",
          sortable: true,
          name: "stdOccupancy",
        },
        {
          text: "Min Occupancy",
          align: "left",
          value: "minOccupancy",
          sortable: true,
          name: "minOccupancy",
        },
        {
          text: "Max Occupancy",
          align: "left",
          value: "maxOccupancy",
          sortable: true,
          name: "maxOccupancy",
        },
        {
          text: "Not In Use",
          align: "left",
          value: "notInUse",
          sortable: true,
          name: "notInUse",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
      listQuery: ALL_TRANSPORT_SERVICE_TYPES_SEARCH_QUERY,
      deleteMutation: TRANSPORT_SERVICE_TYPE_DELETE_MUTATION,
      createMutation: TRANSPORT_SERVICE_TYPE_CREATE_MUTATION,
      updateMutation: TRANSPORT_SERVICE_TYPE_UPDATE_MUTATION,
      modelLabel: "Transport Type",
      GQLtypeName: "transportServiceTypes",
    };
  },

  apollo: {
    transportServiceTypes: {
      query: ALL_TRANSPORT_SERVICE_TYPES_SEARCH_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/TransportTypesList.vue